export default "__VITE_ASSET__CufpL49O__"